/* aloveya product page: places the hub-studio gallery in the media column,
   builds the quantity + add-to-cart row, the "save %" pill and delivery dates.
   Loaded with defer from the product section, so it runs before the
   hub-studio app script (which sits at the end of <body>). */
(function () {
  const marker = document.querySelector('[data-alv-pdp]');
  if (!marker) return;

  const sectionId = marker.dataset.section;
  const form = document.getElementById(`product-form-${sectionId}`);
  const productEl = marker.closest('.product');

  // --- hub-studio: product photos by default; the live personalized preview
  // covers the main image once the customer starts personalizing.
  const host = document.querySelector('[data-hub-studio]');
  const media = productEl && productEl.querySelector('.product__media-wrapper');
  if (host && host.dataset.campaign && media && form) {
    const viewer = media.querySelector('[id^="GalleryViewer-"]') || media;
    viewer.classList.add('alv-viewer');

    const gallery = document.createElement('div');
    gallery.id = 'alv-hub-gallery';
    gallery.className = 'alv-hub-gallery';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'alv-preview-toggle';
    toggle.hidden = true;
    viewer.append(gallery, toggle);

    host.dataset.gallery = '#alv-hub-gallery';
    host.dataset.form = `#product-form-${sectionId}`;
    host.dataset.place = 'manual';
    const buttons = form.querySelector('.product-form__buttons');
    if (buttons) buttons.before(host);

    const showPreview = (on) => {
      productEl.classList.toggle('alv-pdp--preview', on);
      toggle.textContent = on ? 'View product photos' : 'See your design';
    };
    const onCustomize = (event) => {
      if (!event.target.closest('.hubs-form, .hubs-form-wrap, .hubs-toggle')) return;
      if (!gallery.querySelector('canvas')) return;
      toggle.hidden = false;
      showPreview(true);
    };
    host.addEventListener('focusin', onCustomize);
    host.addEventListener('input', onCustomize);
    host.addEventListener('change', onCustomize);
    toggle.addEventListener('click', () => showPreview(!productEl.classList.contains('alv-pdp--preview')));
    media.addEventListener('click', (event) => {
      if (event.target.closest('.thumbnail-list button, .thumbnail, .slider-button')) showPreview(false);
    });
  }

  // --- quantity + add to cart on one row
  const qty = document.getElementById(`Quantity-Form-${sectionId}`);
  const submit = form && form.querySelector('[name="add"]');
  if (qty && submit) {
    const row = document.createElement('div');
    row.className = 'alv-buyrow';
    submit.before(row);
    row.append(qty, submit);
  }

  // --- "save %" pill next to the price
  const renderSave = (price, compare) => {
    const box = document.getElementById(`price-${sectionId}`);
    if (!box) return;
    box.querySelectorAll('.alv-save').forEach((el) => el.remove());
    if (!compare || compare <= price) return;
    const pill = document.createElement('span');
    pill.className = 'alv-save';
    pill.textContent = `save ${Math.round(((compare - price) / compare) * 100)}%`;
    (box.querySelector('.price__container') || box).append(pill);
  };
  renderSave(Number(marker.dataset.price), Number(marker.dataset.compare));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data && event.data.variant;
      if (!variant) return;
      requestAnimationFrame(() => renderSave(variant.price, variant.compare_at_price));
    });
  }

  // --- delivery dates (business days from today)
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days -= 1;
    }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const range = (from, to) =>
    from.getMonth() === to.getMonth()
      ? `${fmt(from)}–${to.getDate()}`
      : `${fmt(from)} – ${fmt(to)}`;
  const today = new Date();

  document.querySelectorAll('[data-alv-dates]').forEach((box) => {
    const spans = {};
    ['proc', 'std', 'exp'].forEach((key) => {
      const [min, max] = (box.dataset[key] || '').split(',').map(Number);
      if (min && max) spans[key] = range(addBusinessDays(today, min), addBusinessDays(today, max));
    });
    spans.today = fmt(today);
    box.querySelectorAll('[data-range]').forEach((el) => {
      if (spans[el.dataset.range]) el.textContent = spans[el.dataset.range];
    });
  });
})();
